import { Menu } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMenu12Line = createIcon(Menu, 12, "Line");
export const IconMenu16Line = createIcon(Menu, 16, "Line");
export const IconMenu20Line = createIcon(Menu, 20, "Line");
export const IconMenu24Line = createIcon(Menu, 24, "Line");
export const IconMenu32Line = createIcon(Menu, 32, "Line");
export const IconMenu48Line = createIcon(Menu, 48, "Line");
export const IconMenu64Line = createIcon(Menu, 64, "Line");
